import domReady from '@wordpress/dom-ready';

domReady(() => {
  document.querySelectorAll('.vcc-search').forEach((container) => {
    const toggle = container.querySelector('.vcc-search--toggle');
    const collapse = container.querySelector('.vcc-search--collapse');

    if (!toggle || !collapse) {
      return;
    }

    let isHoveringToggle = false;
    let isHoveringCollapse = false;
    let isHoveringResults = false;
    let navResultsContainer = null;
    const attachedToResults = new WeakSet();

    function attachResultsListeners(el) {
      if (attachedToResults.has(el)) {
        return;
      }
      attachedToResults.add(el);
      el.addEventListener('mouseenter', () => {
        isHoveringResults = true;
      });
      el.addEventListener('mouseleave', () => {
        isHoveringResults = false;
        closeSearch();
      });
    }

    // Track which results container SearchWP activates while the nav is open.
    const resultsObserver = new MutationObserver((mutations) => {
      if (!collapse.classList.contains('show')) {
        return;
      }
      for (const mutation of mutations) {
        const el = mutation.target;
        if (
          el.classList.contains('searchwp-live-search-results') &&
          el.classList.contains('searchwp-live-search-results-showing')
        ) {
          navResultsContainer = el;
          attachResultsListeners(el);
        }
      }
    });

    resultsObserver.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    function isTouchDevice() {
      return window.matchMedia('(hover: none)').matches;
    }

    function openSearch() {
      collapse.classList.add('show');
      toggle.setAttribute('aria-expanded', 'true');
      const searchInput = collapse.querySelector(
        'input[type="search"], input[type="text"]'
      );
      if (searchInput) {
        searchInput.focus();
        if (searchInput.value && navResultsContainer) {
          navResultsContainer.classList.add(
            'searchwp-live-search-results-showing'
          );
        }
      }
    }

    function closeSearch() {
      setTimeout(() => {
        if (!isHoveringToggle && !isHoveringCollapse && !isHoveringResults) {
          collapse.classList.remove('show');
          toggle.setAttribute('aria-expanded', 'false');
          if (navResultsContainer) {
            navResultsContainer.classList.remove(
              'searchwp-live-search-results-showing'
            );
          }
        }
      }, 100);
    }

    toggle.addEventListener('mouseenter', () => {
      isHoveringToggle = true;
      openSearch();
    });

    toggle.addEventListener('mouseleave', () => {
      isHoveringToggle = false;
      closeSearch();
    });

    collapse.addEventListener('mouseenter', () => {
      isHoveringCollapse = true;
    });

    collapse.addEventListener('mouseleave', () => {
      isHoveringCollapse = false;
      closeSearch();
    });

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      if (isTouchDevice()) {
        const isOpen = collapse.classList.contains('show');
        if (isOpen) {
          collapse.classList.remove('show');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          openSearch();
        }
      } else {
        openSearch();
      }
    });

    document.addEventListener('click', (e) => {
      if (!isTouchDevice()) {
        return;
      }

      const isOpen = collapse.classList.contains('show');
      const clickedInside =
        toggle.contains(e.target) || collapse.contains(e.target);

      if (isOpen && !clickedInside) {
        collapse.classList.remove('show');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });
});
